import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

$('.owl-carousel').owlCarousel({
  items: 1,
  loop: true,
  nav: false,
  dots: false,
  mouseDrag: false,
  touchDrag: false,
  pullDrag: false,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplaySpeed: 1,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
});

